import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import IconPhoneFull from "app/pages/.shared/static/icons/IconPhoneFull";
import RelativeLink from "app/pages/.shared/RelativeLink";
import "./FaqContact.scss";
import FaqContactModal from "app/pages/Faq/FaqFooter/FaqContact/FaqContactModal";
import Button from "app/pages/.shared/form/Button";
import {
	sendTagOnFaqShowPhoneButtonClick,
	sendTagOnFaqWriteUsButtonClick,
} from "app/utils/analytics";

const FaqContact = ({ hideContactByPhone, helpContactUrl, servicesPhone }) => {
	const [showModal, setShowModal] = useState(false);

	const handlePhoneClick = useCallback(() => {
		sendTagOnFaqShowPhoneButtonClick();
		setShowModal(true);
	}, [showModal]);

	const handleWriteClick = useCallback(() => {
		sendTagOnFaqWriteUsButtonClick();
	}, []);

	const handleCloseModal = useCallback(() => {
		setShowModal(false);
	}, [showModal]);

	return !hideContactByPhone && helpContactUrl ? (
		<div className="faq-contact">
			<div className="faq-contact__title">
				<FormattedMessage id="faq.contact.title" />
			</div>
			<div className="faq-contact__actions">
				{!hideContactByPhone && (
					<Button className="faq-contact__button" onClick={handlePhoneClick}>
						<IconPhoneFull />
						<FormattedMessage id="faq.contact.phone.button.label" />
					</Button>
				)}
				{helpContactUrl && (
					<RelativeLink
						to={{ pathname: helpContactUrl }}
						className="faq-contact__button"
						onClick={handleWriteClick}
					>
						<i className="icon icon--email-white" />
						<FormattedMessage id="faq.contact.write.button.label" />
					</RelativeLink>
				)}
			</div>
			<FaqContactModal
				isOpen={showModal}
				servicesPhone={servicesPhone}
				onClose={handleCloseModal}
			/>
		</div>
	) : null;
};

FaqContact.propTypes = {
	helpContactUrl: PropTypes.string,
	hideContactByPhone: PropTypes.bool,
	servicesPhone: PropTypes.object,
};

export default FaqContact;
